/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './CurriculumPreviewCard.scss'

class CurriculumPreviewCard extends React.Component {
  state = {
    hovering: false,
  }
  render() {
    const {
      subject,
      triggerDetailModal,
      blockIndex,
      taskIndex,
      moveTask,
      t,
    } = this.props
    return (
      <div
        id='CurriculumPreviewCard'
        onMouseEnter={this._startHover}
        onMouseOver={this.state.hovering ? (() => {}) : this._startHover}
        onMouseLeave={this._endHover}
        onClick={() => triggerDetailModal(subject.id)}
      >
        {this.props.active && this.state.hovering ? (
          <div className='grey-out'>
            <div className='task-nav-buttons-container'>
              <i
                className='fa fa-sort-asc'
                aria-hidden='true'
                onClick={e => moveTask(e, -1, taskIndex, blockIndex)}
              />
              <i
                className='fa fa-sort-desc'
                aria-hidden='true'
                onClick={e => moveTask(e, 1, taskIndex, blockIndex)}
              />
            </div>
            <div className='task-play-button-container'>
              <i className='fa fa-play' aria-hidden='true' />
            </div>
            <div className='task-delete-container'>
              <i
                className='fa fa-trash-o'
                aria-hidden='true'
                onClick={e =>
                  this.props.removeActive(
                    e,
                    this.props.blockIndex,
                    this.props.taskIndex
                  )
                }
              />
            </div>
          </div>
        ) : null}
        <div
          className='curriculum-preview-photo-area'
          style={{ backgroundImage: `url(${subject.photo.file_url || subject.photo.fileUrl})` }}
        >
          <div
            className='curriculum-preview-icon'
            style={{ backgroundImage: `url(${subject.icon.file_url || subject.icon.fileUrl})` }}
          />
        </div>
        <div className='curriculum-preview-titlebar'>
          <p className='curriculum-preview-title'>{subject.name}</p>
          <p className='curriculum-preview-label'>{t('lessonPlans.curriculumPreviewCard.curriculum')}</p>
        </div>
        <div className='curriculum-preview-footer'>
          <p>{t('lessonPlans.curriculumPreviewCard.footer', { name: subject.name })}</p>
        </div>
      </div>
    )
  }

  _startHover = () => {
    this.setState({ hovering: true })
  }

  _endHover = () => {
    this.setState({ hovering: false })
  }
}

CurriculumPreviewCard.propTypes = {
  t: PropTypes.func.isRequired,
  subject: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.shape({
      file_url: PropTypes.string,
      fileUrl: PropTypes.string,
    }),
    icon: PropTypes.shape({
      file_url: PropTypes.string,
      fileUrl: PropTypes.string,
    }),
  }),
}

export default withTranslation()(CurriculumPreviewCard)
